<ion-grid class="ion-padding">
  <ion-row>
    <ion-col size="12" sizeLg="8" offsetLg="2">

      <ion-card>
        <ion-card-header>
          <ion-card-title>Hibrid (helyi mappás) mód</ion-card-title>
          <ion-card-subtitle>Az ügykezelés a lemezen lévő mappákban marad – a program csak beolvassa és számozza az ügyeket (read-only).</ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
          <ion-note color="danger" *ngIf="!standalone">
            <ion-icon name="warning" style="vertical-align:middle"></ion-icon>
            A hibrid mód csak a helyi (telepített) alkalmazásban érhető el, mert helyi mappákhoz fér hozzá. A webes felületen nem aktiválható.
          </ion-note>

          <ion-item lines="none" [disabled]="!standalone">
            <ion-toggle [(ngModel)]="aktiv" labelPlacement="end">Hibrid mód bekapcsolása</ion-toggle>
          </ion-item>

          <ion-item>
            <ion-input label="Közös JÜB mappa (PDF)" labelPlacement="stacked" [(ngModel)]="jubMappa"
              [disabled]="!standalone" placeholder="pl. C:\Iroda\JUB"></ion-input>
            <ion-button *ngIf="desktop" slot="end" fill="clear" (click)="tallozJub()" title="Tallózás…"><ion-icon name="folder-open"></ion-icon></ion-button>
          </ion-item>
          <ion-note class="ion-padding-start" color="medium">A program ebből a mappából ellenőrzi és húzza be a JÜB-eket a személyekhez.</ion-note>

          <ion-button expand="block" class="ion-margin-top" (click)="ment()" [disabled]="mentes || !standalone">
            <ion-icon slot="start" name="save"></ion-icon>Beállítások mentése
          </ion-button>
        </ion-card-content>
      </ion-card>

      <ion-card *ngIf="standalone && aktiv">
        <ion-card-header>
          <ion-card-title>Ügyek szinkronizálása a mappákból</ion-card-title>
          <ion-card-subtitle>Az ügytípusokhoz rendelt gyökérmappákból beolvassa és (DB-ben) megszámozza az ügyeket. A mappákat az <b>Ügytípusok</b> menüben kell beállítani.</ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
          <ion-button expand="block" (click)="ugySync()" [disabled]="syncFut">
            <ion-spinner *ngIf="syncFut" slot="start" name="crescent"></ion-spinner>
            <ion-icon *ngIf="!syncFut" slot="start" name="sync"></ion-icon>
            Szinkronizálás most
          </ion-button>
          <div *ngIf="syncEredmeny" class="ion-margin-top">
            <ion-chip color="success" outline="true">{{ syncEredmeny.letrehozott }} új ügy</ion-chip>
            <ion-chip color="medium" outline="true">{{ syncEredmeny.meglevo }} meglévő</ion-chip>
            <ion-list *ngIf="syncEredmeny.hibak?.length" lines="full">
              <ion-item *ngFor="let h of syncEredmeny.hibak" color="light">
                <ion-label class="ion-text-wrap"><h3>{{ h.tipus }}</h3><p>{{ h.hiba }} — {{ h.mappa }}</p></ion-label>
              </ion-item>
            </ion-list>
          </div>
        </ion-card-content>
      </ion-card>

      <ion-card *ngIf="standalone && aktiv">
        <ion-card-header>
          <ion-card-title>JÜB mappa ellenőrzése</ion-card-title>
          <ion-card-subtitle>A közös JÜB mappa PDF fájljainak állapota (almappákban is). Az új/változott fájlok behúzhatók; force-synckel minden fájl újrafeldolgozható.</ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
          <ion-row>
            <ion-col><ion-button expand="block" fill="outline" (click)="jubEllenoriz()"><ion-icon slot="start" name="refresh"></ion-icon>Ellenőrzés</ion-button></ion-col>
            <ion-col><ion-button expand="block" (click)="jubSync(false)" [disabled]="jubFut || jubUjDb === 0">
              <ion-spinner *ngIf="jubFut" slot="start" name="crescent"></ion-spinner>
              <ion-icon *ngIf="!jubFut" slot="start" name="cloud-download"></ion-icon>Új/változott behúzása ({{ jubUjDb }})</ion-button></ion-col>
            <ion-col size="auto"><ion-button color="warning" fill="outline" (click)="jubSync(true)" [disabled]="jubFut" title="Minden fájl újrafeldolgozása">
              <ion-icon slot="icon-only" name="reload-circle"></ion-icon></ion-button></ion-col>
          </ion-row>

          <ion-note color="danger" *ngIf="jubStatusz?.hiba">{{ jubStatusz.hiba }}</ion-note>
          <ion-note color="medium" *ngIf="jubStatusz && !jubStatusz.mappa">Nincs beállítva JÜB mappa.</ion-note>

          <ion-list *ngIf="jubStatusz?.fajlok?.length" lines="full">
            <ion-item *ngFor="let f of jubStatusz.fajlok">
              <ion-icon slot="start" name="document-text" color="medium"></ion-icon>
              <ion-label class="ion-text-wrap">
                <h3>{{ f.fajlnev }}</h3>
                <p *ngIf="f.hiba" color="danger">{{ f.hiba }}</p>
              </ion-label>
              <ion-badge slot="end" [color]="jubSzin(f.allapot)">{{ jubCimke(f.allapot) }}</ion-badge>
            </ion-item>
          </ion-list>
          <ion-note class="ion-padding-start" color="medium" *ngIf="jubStatusz && jubStatusz.mappa && !jubStatusz.fajlok?.length">
            A JÜB mappa üres vagy nincs benne PDF.
          </ion-note>
        </ion-card-content>
      </ion-card>

    </ion-col>
  </ion-row>
</ion-grid>
